import React from 'react'
import { PayPalScriptProvider } from '@paypal/react-paypal-js'
import PaypalCheckout from './PaypalCheckout'

const PaypalWrapper = (props) => {
  const { amount, paypalOptions, onSuccess, onFail } = props
  
  return (
    <PayPalScriptProvider options={paypalOptions}>
      <PaypalCheckout
        amount={amount}
        onSuccess={onSuccess}
        onFail={onFail}
      />
    </PayPalScriptProvider>
  )
}

export default PaypalWrapper